import { Cards } from '../../../components/cards/frame/cards-frame';
import { useState } from 'react';
import { DataService } from '../../../config/dataService/dataService';
import { useEffect } from 'react';

function EmployeeOverview() {
  const [user, setUser] = useState(null);

  useEffect(() => {
  const fetchUserProfile = async () => {
    try {
      const res = await DataService.get('/users/me');
      console.log(res);
      setUser(res?.data?.data);
    } catch (err) {
      console.error('User profile load karne me issue aaya:', err);
    } 
  };
  fetchUserProfile();
}, []);

const profileImg = user?.profileImage;
  return (
  <div>
   <Cards
      title="EMPLOYEE OVERVIEW"
      headless={false}
      border={true}
      className="overview-custom-card"
    >
      <div className="employee-card-body">
        <div className="avatar-box">
          <div className="avatar-circle">
            <span className="avatar-emoji">
              <img src={profileImg || require('../../../static/img/avatar/avatar.png')} />
            </span>
          </div>
        </div>

        <div className="divider-line" />

        <div className="employee-info">
          <div className="info-row top-row">
            <div>
              <span className="label">Employee ID</span>
              <h3 className="value-id">{user?.employeeId}</h3>
            </div>
            <div>
              <span className="label">Name</span>
              <h2 className="value-name">{user?.name}</h2>
            </div>
            <div>
                <span className="sub-label">Office Mobile Number</span>
                <span className="sub-value">{user?.phone}</span>
            </div>
          </div>

          <div className="info-row bottom-row">
            <div>
              <span className="sub-label">Office Mail ID</span>
              <span className="sub-value">{user?.email}</span>
            </div>
            <div>
              <span className="label">Designation</span>
              <h4 className="value-designation">{user?.designation}</h4>
            </div>
            <div className="icon-detail">
              <span className="sub-label">Employee Status</span>
              <div className="status-box">
                 <span className="status-dot green " />
                <span className="sub-value text-green">Present Today</span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </Cards>
    </div>
  );
}

export default EmployeeOverview;
